<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="mypage mypage_change mypage_new-pass">
      <div class="wrap mypage_wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac new-pass">
            <p class="login_two-fac_title">新しいパスワードを設定</p>
            <p class="login_two-fac_ex">パスワードは最低６文字以上です</p>
            <van-form style="width: 100%; max-width: 500px" ref="form">
              <p class="login_cont-name">新しいパスワード</p>
              <div class="login_pass-box">
                <input
                  class="newPassword"
                  name="newPassword"
                  v-model="formData.newPassword"
                  :type="newPwdFlag ? 'password' : 'text'"
                />
                <button class="btn_passview">
                  <img
                    src="@/assets/img/login/pass.png"
                    :class="[this.newPwdFlag ? '' : 'img-opacity']"
                    @click="changeNewPwd"
                    alt="非表示"
                  />
                </button>
              </div>

              <p class="login_cont-name">新しいパスワード（確認用）</p>
              <div class="login_pass-box">
                <input
                  class="confirmPasswd"
                  name="confirmPasswd"
                  v-model="formData.confirmPasswd"
                  :type="ConfirmpwdFlag ? 'password' : 'text'"
                />
                <button class="btn_passview">
                  <img
                    src="@/assets/img/login/pass.png"
                    :class="[this.ConfirmpwdFlag ? '' : 'img-opacity']"
                    @click="changeConfirmpwd"
                    alt="非表示"
                  />
                </button>
              </div>
            </van-form>
          </div>
          <van-button
            :disabled="
              !this.formData.newPassword || !this.formData.confirmPasswd
            "
            block
            :color="
              !this.formData.newPassword || !this.formData.confirmPasswd
                ? '#AACBE7'
                : '#48b2fb'
            "
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="handleSure"
            id="mypage_btn_update"
            >設定する</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UpdatePassword, Logout } from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";
import Janus from "@/assets/js/janus";
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      password: "",
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      formData: {},
      newPwdFlag: true,
      ConfirmpwdFlag: true,
      loading: false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.formData.id = this.user.id;
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    async handleSure() {
      try {
        if (this.formData.newPassword !== this.formData.confirmPasswd) {
          Toast("新しいパスワード一致していません");
          return;
        }
        if (this.formData.newPassword.length < 6) {
          Toast("パスワードは最低６文字以上です");
          return;
        }
        await this.$refs.form.validate();
        const detail = this.formData;
        const res = await UpdatePassword(detail);
        if (res.data.code >= 0) {
          Toast.success("変更に成功しました");
          const code = localStorage.getItem(process.env.VUE_APP_CODE_KEY);
          Logout();
          if (Janus) {
            Janus.videoPageDestory();
          }
          setTimeout(() => {
            this.$router.push({
              path: "/login",
              query: {
                code: code,
              },
            });
          }, 100);
        } else {
          Toast.fail("変更に失敗しました。");
        }
      } catch (error) {
        Toast.fail("変更に失敗しました。");
      } finally {
        this.loading = false;
      }
    },
    changeNewPwd () {
      this.newPwdFlag = !this.newPwdFlag;
    },
    changeConfirmpwd () {
      this.ConfirmpwdFlag = !this.ConfirmpwdFlag;
    },
  },
};
</script>

<style scoped>
   
   
  

#mypage_btn_update {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#mypage_btn_update.possible {
  background: #3b82c4;
  pointer-events: auto;
}
.img-opacity {
  opacity: 0.4;
}
</style>
